import { render, staticRenderFns } from "./EmailsPreview.vue?vue&type=template&id=ca048998&"
import script from "./EmailsPreview.vue?vue&type=script&lang=js&"
export * from "./EmailsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports